import _isEmpty from "lodash/isEmpty";
import "core-js/modules/es6.array.map.js";
// @ts-ignore -- This hasn't been converted to TypeScript yet
import { extractStructuredContent } from '../utils';

/**
 * Get the schema for FAQPage
 *
 * @param  {Array}  faqSections An array of objects representing questions and answers eg:
 *  [
 *    { question: <String>, answer: <String> },
 *    ...
 *  ]
 * @return {Object} FAQPage schema
 */
var getFaqSchema = function getFaqSchema(faqSections) {
  if (_isEmpty(faqSections)) {
    return null;
  }

  return {
    '@type': 'FAQPage',
    mainEntity: faqSections.map(function (_ref) {
      var answer = _ref.answer,
          question = _ref.question;
      return {
        '@type': 'Question',
        name: question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: extractStructuredContent(answer)
        }
      };
    })
  };
};

export default getFaqSchema;